document.addEventListener('DOMContentLoaded', function() {
  const btnCheckout = document.getElementById('checkout');
  const cartItemsLayout = document.getElementById('cart-items-layout');
  const cartFooterSection = document.getElementById('main-cart-footer');
  const shippingStep = document.getElementById('f-shipping-step');
  
  const step1Indicator = document.getElementById('step-1-indicator');
  const step2Indicator = document.getElementById('step-2-indicator');
  const step1Line = document.getElementById('step-1-line');
  const step2Line = document.getElementById('step-2-line');
  
  const btnBackToCart = document.getElementById('f-btn-back-to-cart');
  const btnContinueCheckout = document.getElementById('f-btn-continue-checkout');
  
  // Modal Elements
  const addressModal = document.getElementById('f-address-modal');
  const btnModalClose = document.getElementById('f-modal-close');
  const btnCancelAddress = document.getElementById('f-btn-cancel-address');
  const btnAddAddress = document.getElementById('f-btn-add-address');
  const formAddress = document.getElementById('f-address-form');
  const btnDeleteAddress = document.getElementById('f-btn-delete-address');
  const btnSubmitAddress = document.getElementById('f-btn-submit-address');
  const modalTitle = document.getElementById('f-modal-title');
  const modalSubtitle = document.getElementById('f-modal-subtitle');
  const cartItemsCol = document.querySelector('.cart-page__items');
  const cartSummary = document.querySelector('.cart-page__summary');
  const cartSummarySecondaryBtn = document.querySelector('.cart-summary__btn--outline');

  // Store the node globally in case Shopify AJAX cart wipes it out
  if (shippingStep && !window.fShippingStepNode) {
    window.fShippingStepNode = shippingStep;
  }

  // Move shipping step into the two-column grid
  if (shippingStep && cartItemsLayout && cartSummary) {
    cartItemsLayout.insertBefore(shippingStep, cartSummary);
  }

  // =============================================
  // Navigation Logic (Step 1 <-> Step 2)
  // =============================================
  function showShippingStep() {
    let currentShippingStep = document.getElementById('f-shipping-step');
    if (!currentShippingStep && window.fShippingStepNode) {
      currentShippingStep = window.fShippingStepNode;
    }
    
    // Re-query in case they were replaced by AJAX
    const currentCartItemsLayout = document.getElementById('cart-items-layout') || cartItemsLayout;
    const currentCartSummary = document.querySelector('.cart-page__summary') || cartSummary;
    const currentCartItemsCol = document.querySelector('.cart-page__items') || cartItemsCol;
    
    // Re-insert if it was destroyed by AJAX cart
    if (currentShippingStep && currentCartItemsLayout && currentCartSummary && !currentCartItemsLayout.contains(currentShippingStep)) {
      currentCartItemsLayout.insertBefore(currentShippingStep, currentCartSummary);
    }
    
    if (currentCartItemsCol) currentCartItemsCol.style.setProperty('display', 'none', 'important');
    if (currentShippingStep) currentShippingStep.style.display = 'block';
    
    const recommendations = document.querySelector('.cart-recommendations');
    if (recommendations) recommendations.style.setProperty('display', 'none', 'important');
    
    // Change button in summary
    let currentBtnCheckout = document.getElementById('checkout') || btnCheckout;
    if (currentBtnCheckout) {
      currentBtnCheckout.textContent = 'Continuar';
      currentBtnCheckout.dataset.step = 'shipping';
    }
    
    let currentCartSummarySecondaryBtn = document.querySelector('.cart-summary__btn--outline') || cartSummarySecondaryBtn;
    if (currentCartSummarySecondaryBtn) {
      currentCartSummarySecondaryBtn.style.display = 'none';
    }
    
    if (step1Indicator) step1Indicator.classList.add('cart-stepper__item--active');
    if (step2Indicator) step2Indicator.classList.add('cart-stepper__item--active');
    
    if (step1Line) {
      step1Line.classList.remove('cart-stepper__line--active');
      step1Line.classList.add('cart-stepper__line--completed');
    }
    if (step2Line) step2Line.classList.add('cart-stepper__line--active');
    
    window.scrollTo(0, 0);
  }

  function showCartStep() {
    let currentShippingStep = document.getElementById('f-shipping-step');
    if (!currentShippingStep && window.fShippingStepNode) {
      currentShippingStep = window.fShippingStepNode;
    }
    if (currentShippingStep) currentShippingStep.style.display = 'none';
    
    const currentCartItemsCol = document.querySelector('.cart-page__items') || cartItemsCol;
    if (currentCartItemsCol) currentCartItemsCol.style.removeProperty('display');
    
    const recommendations = document.querySelector('.cart-recommendations');
    if (recommendations) recommendations.style.removeProperty('display');
    
    // Check if the button was re-rendered by AJAX and re-fetch it
    let currentBtnCheckout = document.getElementById('checkout');
    if (!currentBtnCheckout) currentBtnCheckout = btnCheckout;
    
    if (currentBtnCheckout) {
      currentBtnCheckout.textContent = 'Ir a Pagar';
      currentBtnCheckout.dataset.step = 'cart';
    }
    
    let currentCartSummarySecondaryBtn = document.querySelector('.cart-summary__btn--outline') || cartSummarySecondaryBtn;
    if (currentCartSummarySecondaryBtn) {
      currentCartSummarySecondaryBtn.style.display = 'inline-flex';
    }
    
    if (step2Indicator) step2Indicator.classList.remove('cart-stepper__item--active');
    if (step1Indicator) step1Indicator.classList.add('cart-stepper__item--active');
    
    if (step1Line) {
      step1Line.classList.remove('cart-stepper__line--completed');
      step1Line.classList.add('cart-stepper__line--active');
    }
    if (step2Line) step2Line.classList.remove('cart-stepper__line--active');
  }

  window.addEventListener('popstate', function(event) {
    if (event.state && event.state.step === 'shipping') {
      showShippingStep();
    } else {
      showCartStep();
    }
  });

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('step') === 'shipping') {
    showShippingStep();
  } else {
    history.replaceState({ step: 'cart' }, '', window.location.pathname);
  }
  
  document.body.addEventListener('click', function(e) {
    const targetBtn = e.target.closest('#checkout');
    if (targetBtn) {
      if (targetBtn.dataset.step === 'shipping' || (new URLSearchParams(window.location.search).get('step') === 'shipping')) {
        e.preventDefault();
        
        // Validación Cédula
        if (window.farmaCheckoutState) {
          if (window.farmaCheckoutState.isLoggedIn) {
            if (!window.farmaCheckoutState.hasCedula) {
              const loggedCedulaError = document.getElementById('f-logged-cedula-error');
              if (loggedCedulaError) {
                loggedCedulaError.style.display = 'flex';
                // Hacer scroll hacia el error
                loggedCedulaError.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
              return;
            }
          } else {
            const guestCedulaInput = document.getElementById('f-guest-cedula');
            const guestCedulaError = document.getElementById('f-guest-cedula-error');
            if (guestCedulaInput && !guestCedulaInput.value.trim()) {
              if (guestCedulaError) guestCedulaError.style.display = 'flex';
              guestCedulaInput.focus();
              
              // Ocultar el error cuando escriban
              guestCedulaInput.addEventListener('input', function() {
                if (guestCedulaInput.value.trim() && guestCedulaError) {
                  guestCedulaError.style.display = 'none';
                }
              }, { once: true });
              
              return;
            }
          }
        }
        
        const selectedMethodEl = document.querySelector('input[name="shipping_method"]:checked');
        if (!selectedMethodEl) {
          alert('Por favor selecciona un método de envío o dirección.');
          return;
        }
        const selectedMethod = selectedMethodEl.value;
        
        const noteEl = document.getElementById('f-cart-note');
        const note = noteEl ? noteEl.value : '';
        
        const attributes = {
          'shipping_method': selectedMethod
        };

        // A dónde mandamos al cliente al terminar. Por defecto, checkout normal.
        let checkoutUrl = '/checkout';

        let setDefaultAddressPromise = Promise.resolve();
        if (selectedMethod.startsWith('address-')) {
          const addressId = selectedMethod.replace('address-', '');
          attributes['selected_address_id'] = addressId;

          // Si ya es la predeterminada, Shopify la toma sola al armar el checkout
          // (nuevo o retomado) — no hace falta forzar nada, y así el checkout la
          // sigue mostrando como "dirección guardada" en vez de una escrita a mano.
          //
          // Si NO es la predeterminada, el checkout real de Shopify, si ya existe
          // uno abierto para este carrito (por ejemplo porque el cliente ya había
          // pasado por acá antes), no se actualiza solo con cambiar la
          // predeterminada del cliente — se queda con la que tenía la primera vez.
          // Por eso, además de marcarla como predeterminada (para futuras compras),
          // se la pasamos directo al checkout por query params
          // (checkout[shipping_address][...]), que sí fuerza la dirección de ESTE
          // checkout puntual sin importar si es nuevo o uno que se está retomando.
          // Efecto secundario inevitable (limitación de Shopify sin Plus/checkout
          // extensibility: no existe un parámetro para decir "usa la guardada #X"):
          // el checkout la muestra como dirección escrita a mano, no como una de
          // las guardadas del cliente — pero sí llega al pedido correctamente.
          let addressFields = null;
          if (selectedMethodEl.dataset.isDefault !== 'true') {
            try {
              addressFields = JSON.parse(selectedMethodEl.dataset.addressFields || 'null');
            } catch (e) {
              addressFields = null;
            }
          }
          if (addressFields) {
            const params = new URLSearchParams();
            const fieldMap = {
              first_name: 'first_name',
              last_name: 'last_name',
              company: 'company',
              address1: 'address1',
              address2: 'address2',
              city: 'city',
              province: 'province',
              zip: 'zip',
              country: 'country',
              phone: 'phone'
            };
            Object.keys(fieldMap).forEach(key => {
              const value = addressFields[key];
              if (value) {
                params.set('checkout[shipping_address][' + fieldMap[key] + ']', value);
              }
            });
            checkoutUrl = '/checkout?' + params.toString();
          }

          if (selectedMethodEl.dataset.isDefault !== 'true') {
            setDefaultAddressPromise = fetch('/account/addresses/' + addressId, {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: '_method=put&address%5Bdefault%5D=1'
            }).catch(error => {
              console.error('Error setting default address:', error);
            });
          }
        }

        if (window.farmaCheckoutState) {
          if (!window.farmaCheckoutState.isLoggedIn) {
            const guestCedulaInput = document.getElementById('f-guest-cedula');
            if (guestCedulaInput && guestCedulaInput.value.trim()) {
              attributes['cedula'] = guestCedulaInput.value.trim();
            }
          } else if (window.farmaCheckoutState.hasCedula && window.farmaCheckoutState.cedulaValue) {
            attributes['cedula'] = window.farmaCheckoutState.cedulaValue;
          }
        }

        targetBtn.disabled = true;
        targetBtn.textContent = 'Procesando...';

        setDefaultAddressPromise.then(() =>
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              note: note,
              attributes: attributes
            })
          })
        )
        .then(() => {
          window.location.href = checkoutUrl;
        })
        .catch(error => {
          console.error('Error updating cart:', error);
          window.location.href = checkoutUrl;
        });
      } else {
        e.preventDefault();
        history.pushState({ step: 'shipping' }, '', '?step=shipping');
        showShippingStep();
      }
    }
  });
  
  document.body.addEventListener('click', function(e) {
    const targetBackBtn = e.target.closest('#f-btn-back-to-cart');
    if (targetBackBtn) {
      history.pushState({ step: 'cart' }, '', window.location.pathname);
      showCartStep();
    }
  });
  
  document.body.addEventListener('click', function(e) {
    const targetIndicator = e.target.closest('#step-1-indicator');
    if (targetIndicator) {
      let currentShippingStep = document.getElementById('f-shipping-step');
      if (!currentShippingStep && window.fShippingStepNode) {
        currentShippingStep = window.fShippingStepNode;
      }
      if (currentShippingStep && currentShippingStep.style.display === 'block') {
        history.pushState({ step: 'cart' }, '', window.location.pathname);
        showCartStep();
      }
    }
  });
  
  if (step1Indicator) {
    step1Indicator.style.cursor = 'pointer';
  }

  // =============================================
  // Address Modal Logic
  // =============================================
  let currentEditingAddressId = null;

  function openModal(isEdit, addressId) {
    if (!addressModal) return;
    
    const idInput = document.getElementById('f-address-id');
    currentEditingAddressId = isEdit ? addressId : null;
    
    if (isEdit && addressId && window.customerAddresses && window.customerAddresses[addressId]) {
      modalTitle.textContent = 'Editar dirección';
      modalSubtitle.textContent = 'Completa los campos para editar tu dirección';
      if (btnDeleteAddress) btnDeleteAddress.style.display = 'block';
      if (idInput) idInput.value = addressId;
      
      const addr = window.customerAddresses[addressId];
      
      // Pre-fill fields
      const setVal = (id, val) => { const el = document.getElementById(id); if (el) el.value = val || ''; };
      setVal('f-address-first-name', addr.first_name);
      setVal('f-address-last-name', addr.last_name);
      setVal('f-address-address1', addr.address1);
      setVal('f-address-address2', addr.address2);
      setVal('f-address-city', addr.city);
      setVal('f-address-zip', addr.zip);
      setVal('f-address-phone', addr.phone);
      
      // Set country & trigger province selector
      const countrySelect = document.getElementById('f-address-country');
      if (countrySelect && addr.country) {
        countrySelect.value = addr.country;
        countrySelect.dispatchEvent(new Event('change'));
        // Province gets populated by CountryProvinceSelector on change
        // Set province after a small delay to let it populate
        setTimeout(() => {
          const provinceSelect = document.getElementById('f-address-province');
          if (provinceSelect && addr.province) {
            provinceSelect.value = addr.province;
          }
        }, 200);
      }
      
      // Default checkbox
      const defaultCheckbox = document.getElementById('f-address-default');
      if (defaultCheckbox) defaultCheckbox.checked = !!addr.default;
      
    } else {
      modalTitle.textContent = 'Agregar dirección';
      modalSubtitle.textContent = 'Completa los campos para agregar una nueva dirección';
      if (btnDeleteAddress) btnDeleteAddress.style.display = 'none';
      if (idInput) idInput.value = '';
      
      // Reset all fields
      const fields = ['f-address-first-name', 'f-address-last-name', 'f-address-address1',
                       'f-address-address2', 'f-address-city', 'f-address-zip', 'f-address-phone'];
      fields.forEach(id => { const el = document.getElementById(id); if (el) el.value = ''; });
      
      // Default country to Colombia
      const countrySelect = document.getElementById('f-address-country');
      if (countrySelect) {
        countrySelect.value = 'Colombia';
        countrySelect.dispatchEvent(new Event('change'));
      }
      
      const defaultCheckbox = document.getElementById('f-address-default');
      if (defaultCheckbox) defaultCheckbox.checked = false;
    }
    
    addressModal.style.display = 'flex';
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');
  }

  function closeModal() {
    if (addressModal) addressModal.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    currentEditingAddressId = null;
  }

  // Open modal: Add
  if (btnAddAddress) {
    btnAddAddress.addEventListener('click', () => openModal(false, null));
  }

  // Open modal: Edit (for each edit button)
  document.querySelectorAll('.f-btn-edit-address').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const addressId = e.currentTarget.dataset.addressId;
      openModal(true, addressId);
    });
  });

  // Close modal
  if (btnModalClose) btnModalClose.addEventListener('click', closeModal);
  if (btnCancelAddress) btnCancelAddress.addEventListener('click', closeModal);
  
  // Close on overlay click
  if (addressModal) {
    addressModal.addEventListener('click', (e) => {
      if (e.target === addressModal) closeModal();
    });
  }

  // =============================================
  // Form Submit (Create / Update) via AJAX
  // =============================================
  if (formAddress) {
    formAddress.addEventListener('submit', function(e) {
      e.preventDefault();
      const addressId = currentEditingAddressId;
      const isEdit = !!addressId;
      const url = isEdit ? '/account/addresses/' + addressId : '/account/addresses';
      
      const formData = new FormData(formAddress);
      
      let phoneVal = formData.get('address[phone]');
      if (phoneVal) {
        // Remove spaces
        phoneVal = phoneVal.replace(/\s+/g, '');
        
        // If they just typed 57 at the start, make it +57
        if (phoneVal.startsWith('57') && phoneVal.length > 10) {
          phoneVal = '+' + phoneVal;
        } 
        // If it doesn't have +57, add it
        else if (!phoneVal.startsWith('+57')) {
          // If they typed a different country code, leave it, but otherwise assume Colombia
          if (!phoneVal.startsWith('+')) {
            phoneVal = '+57' + phoneVal;
          }
        }
        formData.set('address[phone]', phoneVal);
      }

      if (isEdit) {
        formData.append('_method', 'put');
      }
      
      if (btnSubmitAddress) {
        btnSubmitAddress.textContent = 'Guardando...';
        btnSubmitAddress.disabled = true;
      }

      fetch(url, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        // Shopify responde con un redirect (302) cuando la dirección se guarda bien,
        // y con un 200 (re-renderiza el formulario con errores) cuando falla. Con
        // 'manual' no seguimos la redirección — solo necesitamos saber si la hubo,
        // sin depender de a dónde apunte ni de si esa página carga bien.
        redirect: 'manual'
      })
      .then(response => {
        if (response.type === 'opaqueredirect' || response.ok || response.redirected) {
          window.location.href = window.location.pathname + '?step=shipping';
        } else {
          return response.text().then(text => { throw new Error(text); });
        }
      })
      .catch(() => {
        if (btnSubmitAddress) {
          btnSubmitAddress.textContent = 'Guardar';
          btnSubmitAddress.disabled = false;
        }
        alert('Hubo un problema al guardar la dirección. Revisa los datos e intenta de nuevo.');
      });
    });
  }

  // =============================================
  // Delete Address
  // =============================================
  if (btnDeleteAddress) {
    btnDeleteAddress.addEventListener('click', function() {
      if (!currentEditingAddressId) return;
      if (!confirm('¿Estás seguro de que deseas eliminar esta dirección?')) return;
      
      btnDeleteAddress.textContent = 'Eliminando...';
      btnDeleteAddress.disabled = true;

      const formData = new FormData();
      formData.append('_method', 'delete');
      
      fetch('/account/addresses/' + currentEditingAddressId, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(response => {
        if (response.ok || response.redirected) {
          window.location.href = window.location.pathname + '?step=shipping';
        } else {
          alert('Hubo un error al eliminar la dirección.');
          btnDeleteAddress.textContent = 'Eliminar';
          btnDeleteAddress.disabled = false;
        }
      })
      .catch(() => {
        btnDeleteAddress.textContent = 'Eliminar';
        btnDeleteAddress.disabled = false;
      });
    });
  }

  // =============================================
  // Prevent Native Cart Submit on Radio Change
  // =============================================
  document.querySelectorAll('input[name="shipping_method"]').forEach(radio => {
    radio.addEventListener('change', (e) => {
      e.stopPropagation();
    });
  });

});
